import React from 'react';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Colors } from '@constants/colors';

interface WatchlistRowProps {
  symbol: string;
  name: string;
  price: number | null;
  changePercent: number;
  isInWatchlist: boolean;
  onPress: () => void;
  onWatchlistToggle: () => void;
}

export const WatchlistRow: React.FC<WatchlistRowProps> = ({
  symbol,
  name,
  price,
  changePercent,
  isInWatchlist,
  onPress,
  onWatchlistToggle,
}) => {
  const isPositive = changePercent >= 0;
  const changeColor = isPositive ? Colors.market.profit : Colors.market.loss;

  const handleStarPress = (e: any) => {
    e.stopPropagation();
    onWatchlistToggle();
  };

  return (
    <Pressable onPress={onPress} style={styles.row}>
      <View style={styles.leftSection}>
        <Text style={styles.symbol}>{symbol}</Text>
        <Text style={styles.name} numberOfLines={1}>
          {name}
        </Text>
      </View>

      <View style={styles.rightSection}>
        <Text style={styles.price}>{price !== null ? `$${price.toFixed(2)}` : '–'}</Text>
        <Text style={[styles.change, { color: changeColor }]}>
          {isPositive ? '+' : ''}
          {changePercent.toFixed(2)}%
        </Text>
      </View>

      {/* Subtle Star */}
      <Pressable onPress={handleStarPress} style={styles.starButton} hitSlop={8}>
        <Ionicons
          name={isInWatchlist ? 'star' : 'star-outline'}
          size={18}
          color={isInWatchlist ? Colors.text.secondary : Colors.text.tertiary}
          style={{ opacity: isInWatchlist ? 1.0 : 0.6 }}
        />
      </Pressable>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderBottomWidth: 1,
    borderBottomColor: Colors.border.subtle,
  },
  leftSection: {
    flex: 1,
    marginRight: 12,
  },
  symbol: {
    fontSize: 16,
    fontWeight: '600',
    color: Colors.text.primary,
    marginBottom: 2,
  },
  name: {
    fontSize: 13,
    color: Colors.text.tertiary,
  },
  rightSection: {
    alignItems: 'flex-end',
    marginRight: 12,
  },
  price: {
    fontSize: 16,
    fontWeight: '600',
    color: Colors.text.primary,
    marginBottom: 2,
  },
  change: {
    fontSize: 13,
    fontWeight: '500',
  },
  starButton: {
    padding: 4,
  },
});
